import React from "react";
import { Row, Col } from "reactstrap";
import { TopicQuickMetrics } from "../../../../Models/TopicQuickMetrics";
import TopicMetricDisplay from "./TopicMetricDisplay";

type Props = {
  metrics: TopicQuickMetrics;
};

export default class TopicSummaryGridItem extends React.Component<Props> {
  render() {
    return (
      <Row>
        <Col sm={2}>{/* Should be empty to align with title */}</Col>
        <Col sm={10}>
          <TopicMetricDisplay
            metricDescription="Total Number of Open Feedbacks"
            metricValue={`${this.props.metrics.totalOpenFeedback.toString()} / ${this.props.metrics.totalFeedback.toString()}`}
          />
        </Col>
      </Row>
    );
  }
}
